window.DiscountCalculator = window.DiscountCalculator || {
  calculateDiscount: function(compareAtPrice, salePrice) {
    if (!compareAtPrice || !salePrice || compareAtPrice <= salePrice) {
      return 0;
    }

    const discountAmount = compareAtPrice - salePrice;
    const rawPercentage = (discountAmount / compareAtPrice) * 100;
    
    const decimalPart = rawPercentage % 1;
    return decimalPart < 0.55 ? Math.floor(rawPercentage) : Math.ceil(rawPercentage);
  },

  updateBadge: function(badgeElement, compareAtPrice, salePrice) {
    if (!badgeElement) return;

    const discount = this.calculateDiscount(compareAtPrice, salePrice);
    
    if (discount > 0) {
      badgeElement.textContent = `-${discount}%`;
      badgeElement.style.display = '';
    } else {
      badgeElement.style.display = 'none';
    }
  },

  findHighestDiscount: function(variants) {
    let highest = 0;
    
    variants.forEach(variant => {
      const discount = this.calculateDiscount(variant.compareAtPrice, variant.price);
      if (discount > highest) {
        highest = discount;
      }
    });
    
    return highest;
  }
};
